/**
 * The figures a host payable can be built from. Mirrors the backend enum — a payable is a sum of these,
 * each added or subtracted, so any per-game composition is the same feature configured differently.
 */
export enum PayableComponentTypes {
  CharityAllocations = 1,
  WinnerPrize = 2,
  HostAdminFee = 3,
  CausableFees = 4,
  CausableFeesTax = 5,
  StripeFees = 6,
  GrossSales = 7
}

/** Labels for the picker; the API sends its own label with each report line. */
export const PAYABLE_COMPONENT_LABELS: {type: PayableComponentTypes; label: string}[] = [
  {type: PayableComponentTypes.CharityAllocations, label: 'Charity / group allocations'},
  {type: PayableComponentTypes.WinnerPrize, label: 'Winner prize'},
  {type: PayableComponentTypes.HostAdminFee, label: 'Host admin fee'},
  {type: PayableComponentTypes.CausableFees, label: 'Causable fees'},
  {type: PayableComponentTypes.CausableFeesTax, label: 'Causable fees tax'},
  {type: PayableComponentTypes.StripeFees, label: 'Stripe fees'},
  {type: PayableComponentTypes.GrossSales, label: 'Gross sales'}
];
